import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";

const Section6Text78b = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {
    houseAreaAccordingNesahRishum,
  } = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(houseAreaAccordingNesahRishum) && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={styles.bold}>שטח בהתאם לנסח הרישום (מפנקס הזכויות): </span>
          <span>{getBreakLinesTextShumaType3(houseAreaAccordingNesahRishum)}</span>
        </div>
      )}
    </div>
  )
});

export default Section6Text78b;
